
    var riot = require('riot')
    import context from 'static/script/app/ui/checkout2/context/context';
riot.tag2('invoice-payment', '<div class="co-radio-new {co-radio-selected:model.selectedPaymentType === \'InvoicePayment\'}"> <div class="header" onclick="{selectPaymentType}"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div class="icon-braintree-invoice"></div> </div> <div class="cell cell-title"> Faktura </div> <div class="cell-right"> &nbsp; </div> </div> <div class="body co-inner-list"> <div class="swish-container"> Betala frakten med din nästa Tradera-faktura! </div> </div> </div>', '', '', function(opts) {
        this.context = context;
        this.model = opts.model;

        this.context.observable.on('payment-type-selected', function (type) {
        }.bind(this));

        this.selectPaymentType = function () {
            if (this.model.selectedPaymentType === 'InvoicePayment')
                return;

            this.context.observable.trigger('payment-type-selected', 'InvoicePayment');
        }

});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/invoice-payment.riot.html